import { ISelectValue, LinkAndDocument } from '@/@types'
import { DataTableFacetedFilter } from '@/components/data-table/faceted-filter'
import { Table } from '@tanstack/react-table'

interface Props {
  table?: Table<LinkAndDocument>
}

export function TableToolbar({ table }: Props) {
  const LEVELS: ISelectValue[] = [
    { label: 'Nível 1', value: 'level 1' },
    { label: 'Nível 2', value: 'level 2' },
    { label: 'Nível 3', value: 'level 3' },
    { label: 'Nível 4', value: 'level 4' },
    { label: 'Nível 5', value: 'level 5' },
  ]

  if (!table) return null

  return (
    <>
      {LEVELS && (
        <DataTableFacetedFilter
          title="Nível"
          table={table}
          columnId="level"
          options={LEVELS}
        />
      )}
    </>
  )
}
